import { z } from "zod";
import {
  ControlDataTypeKey,
  Types,
  Schema
} from "../prop-controllers";
import { P, match } from "ts-pattern";
const gridColumnSchema = z.object({
  count: z.number(),
  spans: z.array(z.array(z.number()))
});
const gridDataSchema = z.object({
  elements: z.array(Schema.element),
  columns: Schema.responsiveValue(gridColumnSchema)
});
const gridPropControllerDataV0Schema = gridDataSchema;
const GridPropControllerDataV1Type = "prop-controllers::grid::v1";
const gridPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(GridPropControllerDataV1Type),
  value: gridDataSchema
});
const gridPropControllerDataSchema = z.union([
  gridPropControllerDataV0Schema,
  gridPropControllerDataV1Schema
]);
function Grid(options = {}) {
  return { type: Types.Grid, version: 1, options };
}
function getGridPropControllerDataGridData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: GridPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createGridPropControllerDataFromGridData(value, definition) {
  return match(definition).with(
    { version: 1 },
    P.nullish,
    () => ({
      [ControlDataTypeKey]: GridPropControllerDataV1Type,
      value
    })
  ).otherwise(() => value);
}
function mergeGridDataTranslatedData(data, context) {
  return {
    ...data,
    elements: data.elements.map(
      (element) => context.mergeTranslatedData(element)
    )
  };
}
function mergeGridPropControllerTranslatedData(data, context) {
  return match(data).with(
    { [ControlDataTypeKey]: GridPropControllerDataV1Type },
    (v1) => ({
      [ControlDataTypeKey]: GridPropControllerDataV1Type,
      value: mergeGridDataTranslatedData(v1.value, context)
    })
  ).otherwise((v0) => mergeGridDataTranslatedData(v0, context));
}
function getGridPropControllerElementChildren(data) {
  return getGridPropControllerDataGridData(data)?.elements ?? [];
}
function copyGridData(data, context) {
  return {
    ...data,
    elements: data.elements.map((element) => context.copyElement(element))
  };
}
function copyGridPropControllerData(data, context) {
  return match(data).with(void 0, () => void 0).with(
    { [ControlDataTypeKey]: GridPropControllerDataV1Type },
    (v1) => ({
      [ControlDataTypeKey]: GridPropControllerDataV1Type,
      value: copyGridData(v1.value, context)
    })
  ).otherwise((v0) => copyGridData(v0, context));
}
function getGridPropControllerGetElementPath(data, elementKey) {
  const value = getGridPropControllerDataGridData(data);
  const idx = value?.elements.findIndex((element) => element.key === elementKey) ?? -1;
  if (idx === -1)
    return null;
  return match(data).with({ [ControlDataTypeKey]: GridPropControllerDataV1Type }, (_v1) => [
    "value",
    "elements",
    idx
  ]).otherwise((_v0) => ["elements", idx]);
}
export {
  Grid,
  GridPropControllerDataV1Type,
  copyGridPropControllerData,
  createGridPropControllerDataFromGridData,
  getGridPropControllerDataGridData,
  getGridPropControllerElementChildren,
  getGridPropControllerGetElementPath,
  gridPropControllerDataSchema,
  mergeGridPropControllerTranslatedData
};
//# sourceMappingURL=grid.js.map